import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "material-design-icons-iconfont/dist/material-design-icons.css";
import '@fortawesome/fontawesome-free/css/all.css'
import vuetify from "./plugins/vuetify";
import Meta from "vue-meta";
import langs from "./plugins/langs";

Vue.config.productionTip = false;
Vue.use(Meta);
Vue.use(langs)

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount("#app");
